import "@/App.css";
import "@/index.css";
import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";

import Landing from "@/pages/Landing";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import FAQPage from "@/pages/FAQPage";
import LandingAds from "@/pages/LandingAds";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import AuthCallback from "@/pages/AuthCallback";
import ClientDashboard from "@/pages/ClientDashboard";
import NewCase from "@/pages/NewCase";
import ClientCaseDetail from "@/pages/ClientCaseDetail";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminCaseDetail from "@/pages/AdminCaseDetail";

function RootRoute() {
  const { user } = useAuth();
  // Check URL fragment (not query params) for OAuth callback session_id.
  // Placed inside RouterRoutes so useLocation is reactive.
  if (user === null) return null;
  return <Landing />;
}

function RouterRoutes() {
  const location = useLocation();
  // Synchronous check during render — handles OAuth session_id in hash
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<RootRoute />} />
      <Route path="/about" element={<About />} />
      <Route path="/services" element={<Services />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/faq" element={<FAQPage />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/lp/:slug" element={<LandingAds />} />

      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password/:token" element={<ResetPassword />} />

      <Route path="/dashboard" element={<ProtectedRoute role="client"><ClientDashboard /></ProtectedRoute>} />
      <Route path="/dashboard/new" element={<ProtectedRoute role="client"><NewCase /></ProtectedRoute>} />
      <Route path="/dashboard/cases/:id" element={<ProtectedRoute role="client"><ClientCaseDetail /></ProtectedRoute>} />

      <Route path="/admin" element={<ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>} />
      <Route path="/admin/cases/:id" element={<ProtectedRoute role="admin"><AdminCaseDetail /></ProtectedRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <ScrollToTop />
        <RouterRoutes />
      </BrowserRouter>
      <Toaster position="top-right" theme="light" richColors />
    </AuthProvider>
  );
}
